import React from 'react'

import { Restaurant } from 'schema-dts'

import { OORestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { SiteData, SiteRestaurantLocation } from 'shared/js/types'

import { ScheduleType } from 'public/components/online_ordering/types'
import { Menus } from 'public/components/online_ordering/useOOMenu'
import { buildBaseRestaurantSchema } from 'public/components/seo/restaurantSchemaBuilder'
import SchemaThing from 'public/components/seo/SchemaThing'

type Props = {
  restaurant:
    | Pick<
        OORestaurant,
        'name' | 'location' | 'i18n' | 'googlePlaceId' | 'giftCardLinks'
      >
    | undefined
  site: Pick<SiteData, 'meta' | 'config' | 'lastPublishedAt'>
  selectedLocation: SiteRestaurantLocation
  locationSchedule: ScheduleType | undefined
  menus: Menus | undefined
}

const OrderPageSchema = ({
  restaurant,
  site,
  selectedLocation,
  locationSchedule,
  menus
}: Props) => {
  if (!restaurant) {
    return null
  }
  return (
    <SchemaThing<Restaurant>
      json={(routes) => ({
        ...buildBaseRestaurantSchema({
          restaurantName: restaurant.name,
          restaurantPhone: restaurant.location.phone,
          country: restaurant.i18n.country,
          currency: restaurant.i18n.currency,
          selectedLocation,
          locationSchedule,
          site,
          locationUrl: routes.location,
          homeUrl: routes.homeUrl,
          lastPublishedAt: site.lastPublishedAt,
          googlePlaceId: restaurant.googlePlaceId,
          giftCardPurchaseUrl: restaurant.giftCardLinks?.purchaseLink
        }),
        hasMenu: {
          '@type': 'Menu',
          '@id': `${routes.location}`,
          hasMenuSection: menus?.map((menu) => ({
            '@type': 'MenuSection',
            '@id': `${routes.location}#${menu?.guid}`,
            name: menu?.name,
            hasMenuSection: menu.groups
              ?.filter((group) => group != null)
              .map((menuGroup) => ({
                '@type': 'MenuSection',
                '@id': `${routes.location}#${menuGroup?.guid}`,
                name: menuGroup?.name,
                description: menuGroup?.description,
                hasMenuItem: menuGroup?.items?.map((menuItem) => ({
                  '@type': 'MenuItem',
                  url: menuItem?.guid
                    ? routes.menuItemUrl(
                        selectedLocation.externalId,
                        menuItem.name || '',
                        menuItem.guid
                      )
                    : undefined
                }))
              }))
          }))
        }
      })}
    />
  )
}

export default OrderPageSchema
